import Vue from 'vue';
import Router from 'vue-router';
import Show from '@/pages/show'; // 首页
import Login from '@/pages/login'; // 登录页面
import RevisePwd from '@/pages/revisePwd'; // 修改密码页面
import RegistUser from '@/pages/regist/registUser'; // 注册账号页面
import RegistType from '@/pages/regist/registType'; // 注册选择类型页面
import RegistData from '@/pages/regist/registData'; // 个人资料填写页面
import Protocol from '@/pages/protocol'; // 东方号协议
import Homepage from '@/pages/homepage'; // 主页
import AppHomepage from '@/pages/AppHomepage'; // 主页
import Pagearticlelist from '@/pages/pagearticlelist'; // 文章管理
import Message from '@/pages/message'; // 消息中心
import Pageatlas from '@/pages/pageatlas'; // 发布图集
import EditImgList from '@/components/pageatlas/editImgList'; // 图集图片编辑
import ImgListSort from '@/components/pageatlas/ImgListSort'; // 图集图片排序
import Pagevideo from '@/pages/pagevideo'; // 发布视频
import PageArticle from '@/pages/pageArticle'; // 发布视频
import analysisMain from '@/components/analysis/analysisMain'; // 数据分析
import singSucess from '@/pages/singSucess'; // 数据分析

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', redirect: 'Login' },
    { path: '/Show', name: 'Show', component: Show },
    { path: '/Login', name: 'Login', component: Login },
    { path: '/Homepage', name: 'Homepage', component: Homepage },
    { path: '/AppHomepage', name: 'AppHomepage', component: AppHomepage },
    { path: '/RevisePwd', name: 'RevisePwd', component: RevisePwd },
    { path: '/RegistUser', name: 'RegistUser', component: RegistUser },
    { path: '/RegistType', name: 'RegistType', component: RegistType },
    { path: '/RegistData', name: 'RegistData', component: RegistData },
    { path: '/Protocol', name: 'Protocol', component: Protocol },
    { path: '/Pagearticlelist', name: 'Pagearticlelist', component: Pagearticlelist },
    { path: '/Message', name: 'Message', component: Message },
    { path: '/Pageatlas', name: 'Pageatlas', component: Pageatlas },
    { path: '/EditImgList', name: 'EditImgList', component: EditImgList },
    { path: '/ImgListSort', name: 'ImgListSort', component: ImgListSort },
    { path: '/Pagevideo', name: 'Pagevideo', component: Pagevideo },
    { path: '/analysisMain', name: 'Pagevideo', component: analysisMain },
    { path: '/pageArticle', name: 'Pagevideo', component: PageArticle },
    { path: '/singSucess', name: 'singSucess', component: singSucess },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js